import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { CONTROLLERS: { EXPENSES: { BASE: EXPENSES_BASE } } } = USER;
const { CONTROLLERS: { STATEMENTS: { BASE: STATEMENTS_BASE } } } = USER;
const { METHOD: { GET }, DOC_TYPE: { EXPENSES } } = HOOKS_SETTINGS;

export const useDownloadDocQuery = ({ customerId, externalId, docType }: {customerId: string, externalId: string, docType: string }) => useQuery(
  [docType, externalId],
  async () => {
    if (!customerId || !externalId || !docType) {
      return '';
    }
    try {
      const BASE = docType === EXPENSES ? EXPENSES_BASE : STATEMENTS_BASE;
      const { data } = await httpService({
        url: `${BASE_URL}/api/v1/user/${customerId}/${BASE}/${externalId}`,
        method: GET,
        responseType: 'blob',
      });
      return URL.createObjectURL(data);
    } catch (e) {
      if (!process.env.TESTING) console.error(e);
      return '';
    }
  },
  {
    refetchOnWindowFocus: false,
    cacheTime: 0,
    staleTime: 0,
  },
);
